import React, { useEffect, useState } from 'react';
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import { UserAuth,fetchAdminPassword } from "../../authContext";
import { db } from '../../firebase';
import { collection, getDocs, doc, getDoc,addDoc, query, where, updateDoc, arrayUnion, arrayRemove, setDoc, deleteDoc } from 'firebase/firestore';
import { FaWhatsapp, FaPlus } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
const Projects = () => {
    const navigate = useNavigate();
    const { user } = UserAuth();
    const [userProjects, setUserProjects] = useState([]);
    const [activeProjects, setActiveProjects] = useState([]);
    const [oldProjects, setOldProjects] = useState([]);
    const [completed, setCompleted] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [password, setPassword] = useState('');
    const [showJoinModal, setShowJoinModal] = useState(false);
    const [showNewProjectModal, setShowNewProjectModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [newProjectDetails, setNewProjectDetails] = useState({
        name: '',
        descriptionLink: '',
        startDate: '',
        duration: '',
        clubName: '',
        projectPassword: ''
    });
    const [clubs, setClubs] = useState([]);
    useEffect(() => {
        const fetchProjects = async () => {
            if (user) {
                try {
                    const allProjectsSnapshot = await getDocs(collection(db, 'Projects'));
                    const allProjects = allProjectsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                    const userProjectIds = new Set();
                    const userSnapshot = await getDocs(query(collection(db, 'users'), where('email', '==', user.email)));
                    if (!userSnapshot.empty) {
                        const userData = userSnapshot.docs[0].data();
                        userData.projects.forEach(projectRef => userProjectIds.add(projectRef.id));
                    }

                    const userProjects = allProjects.filter(project => userProjectIds.has(project.id) && project.active);
                    const completed = allProjects.filter(project => userProjectIds.has(project.id) && !project.active);
                    const activeProjects = allProjects.filter(project => !userProjectIds.has(project.id) && project.active);
                    const oldProjects = allProjects.filter(project => !userProjectIds.has(project.id) && !project.active);
                    
                    setUserProjects(userProjects);
                    setActiveProjects(activeProjects);
                    setOldProjects(oldProjects);
                    setCompleted(completed);
                } catch (error) {
                    console.error("Error fetching projects:", error);
                }
            }
        };

        fetchProjects();
    }, [user]);

    useEffect(() => {
        const fetchClubs = async () => {
            try {
                const clubsSnapshot = await getDocs(collection(db, 'Clubs'));
                const clubsData = clubsSnapshot.docs.map(doc => doc.data().name);
                setClubs(clubsData);
            } catch (error) {
                console.error("Error fetching clubs:", error);
            }
        };

        fetchClubs();
    }, []);
    const handleEndProject = async (projectId) => {
        const enteredAdminPassword = prompt('Enter admin password:');
        if (enteredAdminPassword === await fetchAdminPassword()) {
            try {
                // Update project to inactive
                const projectDocRef = doc(db, 'Projects', projectId);
                await updateDoc(projectDocRef, { active: false });
    
                // Get the current user's ID (assumed to be available via a context or state)
                const userIds = projectDocRef.members
                // Remove project reference from user's document
                console.log('userIds:', userIds);
                console.log('Type of userIds:', Array.isArray(userIds) ? 'Array' : typeof userIds);

                if (Array.isArray(userIds)) {
                    for (const userId of userIds) {
                        const userDocRef = doc(db, 'users', userId);
                        await updateDoc(userDocRef, {
                            projects: arrayRemove(projectDocRef)
                        });
                    }
                } else {
                    console.error('userIds is not an array');
                }
    
                alert('Project ended successfully!');
                window.location.reload();
            } catch (error) {
                console.error("Error ending project:", error);
                alert('Failed to end the project. Please try again later.');
            }
        } else {
            alert('Incorrect admin password.');
        }
    };
    
    const handleDevelopProject = async (projectId) => {
        const enteredAdminPassword = prompt('Enter admin password:');
        if (enteredAdminPassword === await fetchAdminPassword() ) {
            try {
                const projectDocRef = doc(db, 'Projects', projectId);
                await updateDoc(projectDocRef, {
                    active: true
                });
    
                alert('Project is ready to develop!');
                window.location.reload();
            } catch (error) {
                console.error("Error developing project:", error);
                alert('Failed to develop the project. Please try again later.');
            }
        } else {
            alert('Incorrect admin password.');
        }
    };


    const handleRequestClick = async (projectID) => {    
        // Find the project in the activeProjects array
        const project = activeProjects.find((proj) => proj.id === projectID);
        if (!project) {
            alert('Project not found in active projects.');
            return;
        }
        
    
        // Prepare the request data
        const requestData = {
            name: user.displayName,
            projID: project.id,
            userEmail: user.email, // Get user email from context
            club: project.clubName,
            projectName: project.name, // Get project name from activeProjects
            timestamp: new Date(), // Current timestamp
            type: 'Join', // Set type as 'Join'
        };
    
        // Submit request to Firestore
        try {
            await addDoc(collection(db, 'requests'), requestData);
            alert('Join request submitted successfully!');
        } catch (error) {
            console.error("Error submitting join request:", error);
            alert('Failed to submit the join request. Please try again.');
        }
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleJoin = async () => {
        try {
            // Fetch the user document
            const userQuerySnapshot = await getDocs(query(collection(db, 'users'), where('email', '==', user.email)));
    
            if (userQuerySnapshot.empty) {
                console.error("No user document found with the email:", user.email);
                alert('User data not found. Please try again later.');
                return;
            }
    
            const userDocRef = userQuerySnapshot.docs[0].ref;
            const userDoc = await getDoc(userDocRef);
    
            if (!userDoc.exists()) {
                alert('User document not found');
                return;
            }
    
            const userData = userDoc.data();
    
            // Check if 'pendingJoinRequests' exists, and initialize it if it doesn't
            const pendingJoinRequests = userData.pendingJoinRequests || [];
    
            // Check if the user has reached the limit of 3 pending join requests
            if (pendingJoinRequests.length >= 3) {
                alert('You have reached the maximum number of 3 pending join requests. Please wait for them to be processed before making more requests.');
                return;
            }
    
            // Fetch the project document
            const projectDocRef = doc(db, 'Projects', selectedProject);
            const projectDoc = await getDoc(projectDocRef);
    
            if (projectDoc.exists()) {
                const projectData = projectDoc.data();
    
                // Check if the password is correct
                if (projectData.password === password) {
                    // Add the project join request to the pendingJoinRequests array
                    await updateDoc(userDocRef, {
                        pendingJoinRequests: arrayUnion(selectedProject)
                    });
    
                    // Add the user to the project's members list
                    await updateDoc(projectDocRef, {
                        members: arrayUnion(user.uid)
                    });
    
                    alert('Successfully joined the project!');
                    setShowJoinModal(false);
                    setPassword('');
                    setUserProjects(prevProjects => [...prevProjects, projectData]);
                    setActiveProjects(prevProjects => prevProjects.filter(project => project.id !== selectedProject));
                } else {
                    alert('Incorrect password');
                }
            } else {
                alert('Project not found');
            }
        } catch (error) {
            console.error("Error joining project:", error);
            alert('Failed to join the project. Please try again later.');
        }
    };
    
    
    
    async function getUserIdByEmail(email) {
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("email", "==", email));
        const querySnapshot = await getDocs(q);
    
        if (!querySnapshot.empty) {
            return querySnapshot.docs[0].id; // Return the first matching document's ID
        } else {
            console.log("No matching user found");
            return null;
        }
    }
    const handleLeave = async (projectId) => {
        try {
            const leave = window.confirm("Are you sure you want to leave this project? ");
            if(!leave){return}
            const projectDocRef = doc(db, 'Projects', projectId);
            const userQuerySnapshot = await getDocs(query(collection(db, 'users'), where('email', '==', user.email)));
            
            if (userQuerySnapshot.empty) {
                console.error("No user document found with the email:", user.email);
                alert('User data not found. Please try again later.');
                return;
            }

            const userDocRef = userQuerySnapshot.docs[0].ref;
            console.log(userDocRef)
            await updateDoc(userDocRef, {
                projects: arrayRemove(projectDocRef)
            });
            console.log(userDocRef)
            await updateDoc(projectDocRef, {
                members: arrayRemove(userDocRef.id)
            });

            alert('Successfully left the project!');
            setUserProjects(prevProjects => prevProjects.filter(project => project.id !== projectId));
        } catch (error) {
            console.error("Error leaving project:", error);
            alert('Failed to leave the project. Please try again later.');
        }
    };

    const handleNewProjectClick = async () => {
        try {
            
            setShowNewProjectModal(true);
        } catch (error) {
            console.error("Error fetching admin password:", error);
            alert('Failed to verify password. Please try again later.');
        }
    };

    const handleNewProjectInputChange = (e) => {
        const { name, value } = e.target;
        setNewProjectDetails(prevDetails => ({
            ...prevDetails,
            [name]: value
        }));
    };

    const handleNewProjectSubmit = async () => {
        try {
            const newProjectRef = doc(collection(db, 'Projects'));
            await setDoc(newProjectRef, {
                name: newProjectDetails.name,
                descriptionLink: newProjectDetails.descriptionLink,
                startDate: new Date(newProjectDetails.startDate),
                duration: newProjectDetails.duration,
                clubName: newProjectDetails.clubName,
                password: newProjectDetails.projectPassword,
                members: [],
                active: true
            });

            alert('New project created successfully!');
            setShowNewProjectModal(false);
            setNewProjectDetails({
                name: '',
                descriptionLink: '',
                startDate: '',
                duration: '',
                clubName: '',
                projectPassword: ''
            });
            window.location.reload();
        } catch (error) {
            console.error("Error creating new project:", error);
            alert('Failed to create the new project. Please try again later.');
        }
    };

    const handleEditClick = async (projectId) => {
        try {
            setSelectedProject(projectId);
            const projectDocRef = doc(db, 'Projects', projectId);
            const projectDoc = await getDoc(projectDocRef);
    
            if (projectDoc.exists()) {
                const projectData = projectDoc.data();           
                    setNewProjectDetails({
                        name: projectData.name,
                        descriptionLink: projectData.descriptionLink,
                        startDate: projectData.startDate.toDate().toISOString().substr(0, 10),
                        duration: projectData.duration,
                        clubName: projectData.clubName,
                        projectPassword: projectData.password
                    });
                    setShowEditModal(true);
                
            } else {
                alert('Project not found.');
            }
        } catch (error) {
            console.error("Error editing project:", error);
            alert('Failed to load project details. Please try again later.');
        }
    };
    
    const handleEditProjectSubmit = async () => {
        try {
            const projectDocRef = doc(db, 'Projects', selectedProject);
            await updateDoc(projectDocRef, {
                name: newProjectDetails.name,
                descriptionLink: newProjectDetails.descriptionLink,
                startDate: new Date(newProjectDetails.startDate),
                duration: newProjectDetails.duration,
                clubName: newProjectDetails.clubName,
                password: newProjectDetails.projectPassword
            });

            alert('Project updated successfully!');
            setShowEditModal(false);
            window.location.reload();
        } catch (error) {
            console.error("Error updating project:", error);
            alert('Failed to update the project. Please try again later.');
        }
    };

    const handleDeleteProject = async () => {
        // Show a confirmation dialog before deleting the project
        const isConfirmed = window.confirm('Are you sure you want to delete this project? This action cannot be undone.');
      
        if (isConfirmed) {
          try {
            const projectDocRef = doc(db, 'Projects', selectedProject);
            await deleteDoc(projectDocRef);
      
            alert('Project deleted successfully!');
            setShowEditModal(false);
            window.location.reload(); // Refresh the page to reflect changes
          } catch (error) {
            console.error("Error deleting project:", error);
            alert('Failed to delete the project. Please try again later.');
          }
        } else {
          // User canceled the deletion
          console.log('Project deletion canceled by user.');
        }
      };

      const [memberNames, setMemberNames] = useState([]);
      const [showBox, setShowBox] = useState(false);
      const [boxPosition, setBoxPosition] = useState({ top: 0, left: 0 });
      
      const hoverOver = async (project, event) => {
        if (project != null) {
          const membersID = project.members;
          const usersRef = collection(db, 'users');
          let members = [];
      
          for (let memberID of membersID) {
            const userDoc = doc(usersRef, memberID);
            const docSnap = await getDoc(userDoc);
            if (docSnap.exists()) {
              members.push(docSnap.data().name);
            } else {
              console.log('No such document for member ID:', memberID);
            }
          }
      
          // Get the mouse position to show the box near the hovered element
          const rect = event.target.getBoundingClientRect();
          setBoxPosition({ top: rect.top + window.scrollY + 20, left: rect.left + 20 });
      
          setMemberNames(members);
          setShowBox(true);
        }
      };
      
      const handleMouseLeave = () => {
        setShowBox(false);
      };
      const renderProjects = (projects, buttonType) => {
        return projects.length > 0 ? (
          projects.map((project) => {
            const startDate = project.startDate?.toDate().toLocaleDateString();
      
            return (
              <div key={project.id}>
                <div
                  className="item"
                  onDoubleClick={isAdmin ? () => handleEditClick(project.id) : null}
                  onMouseEnter={(e) => {
                    if( isAdmin || (buttonType === 'myProjects') || (buttonType === 'mycompleted')){
                        hoverOver(project, e)}} // Trigger hoverOver when mouse enters
                    }
                  onMouseLeave={handleMouseLeave} // Hide modal on mouse leave
                  style={{ position: 'relative' }} // Ensure the item is the reference for absolute positioning
                >
                  <h3>{project.name}</h3>
                  {buttonType === 'myProjects' || buttonType === 'mycompleted' ? (
                    <a href={project.descriptionLink} target="_blank" rel="noopener noreferrer">
                      <FaWhatsapp size={24} className="whatsapp-icon" />
                    </a>
                  ) : null}
                  <p>Start Date: {startDate}</p>
                  <p>Duration: {project.duration} days</p>
                  <p>Club: {project.clubName}</p>
      
                  {buttonType === 'myProjects' ? (
                    <>
                      <button className="b" onClick={() => handleLeave(project.id)}>
                        Leave
                      </button>
                      <button className="b" onClick={() => handleEndProject(project.id)}>
                        End
                      </button>
                    </>
                  ) : buttonType === 'active' ? (
                    <>
                      <button className="b" onClick={() => handleRequestClick(project.id)}>
                        Request to Join
                      </button>
                      <button className="b" onClick={() => handleEndProject(project.id)}>
                        End
                      </button>
                    </>
                  ) : (
                    <>
                      <button className="b" onClick={() => handleDevelopProject(project.id)}>
                        Develop
                      </button>
                    </>
                  )}
                </div>
                <div>
                {showBox && (
                    <div
                        style={{
                        position: 'absolute',
                        top: boxPosition.top,
                        left: boxPosition.left,
                        backgroundColor: 'rgba(0, 0, 0, 0.63)', // Black with transparency
                        color: 'white',
                        padding: '10px',
                        borderRadius: '5px',
                        zIndex: 1000
                        }}
                    >
                        <div>Members:</div>
                        {memberNames.length > 0 
                            ? memberNames.map((name, index) => (
                                <div key={index}>{name}</div>
                                )) 
                            : "No members"}
                    </div>
                    )}

                </div>
              </div>
            );
          })
        ) : (
          <p>No projects found.</p>
        );
      };

    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                // Simulate a delay to fetch user info
                const storedUser = JSON.parse(localStorage.getItem('user'));
                const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';

                if (storedUser && storedUser.email === user?.email) {
                    setIsAdmin(storedIsAdmin);
                } else {
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error("Failed to fetch admin status:", error);
                setIsAdmin(false);
            } 
        };

        if (user) {
            checkAdminStatus();
        } 
    }, [user]);

    return (
        <div>
            <div className='content'>
                <div className='grid-container'>
                    <div className='column' key={"MP"}>
                        <h2 style={{ textAlign: 'center' }}>My Projects</h2>
                        {renderProjects(userProjects, 'myProjects')}
                    </div>
                    <div className='column' key={"CP"}>
                        <h2 style={{ textAlign: 'center' }}>My Completed Projects</h2>
                        {renderProjects(completed, 'mycompleted')}
                    </div>
                    <div className='column' key={"AP"}>
                        <h2 style={{ textAlign: 'center' }}>Active Projects</h2>
                        {renderProjects(activeProjects, 'active')}
                    </div>
                    <div className='column' key={"OP"}>
                        <h2 style={{ textAlign: 'center' }}>Old Projects</h2>
                        {renderProjects(oldProjects, 'old')}
                    </div>
                </div>
            { isAdmin && <button 
                      className="floating-button"                       
                        onClick={handleNewProjectClick}
                    >
                      <FaPlus style={{ color: 'white' }} />
                    </button>}
                    <button 
            style={{ position: "relative", bottom: "10px" }} 
            onClick={() => navigate("/ProjReq")}
            className="modal-button"  
        >
            Submit Project Proposal
        </button>

            </div>

            {/* Join Modal */}
            {showJoinModal && (
                <div className='modal'>
                    <div className='modal-content'>
                        <h2>Join Project</h2>
                        <input
                            type='password'
                            placeholder='Enter project password'
                            value={password}
                            onChange={handlePasswordChange}
                        />
                        <button onClick={handleJoin}>Join</button>
                        <button onClick={() => setShowJoinModal(false)}>Cancel</button>
                    </div>
                </div>
            )}

            {/* New Project Modal */}
            {showNewProjectModal && (
                <div className='modal'>
                    <div className='modal-content'>
                        <h2>Create New Project</h2>
                        <input
                            type='text'
                            name='name'
                            placeholder='Project Name'
                            value={newProjectDetails.name}
                            onChange={handleNewProjectInputChange}
                        />
                        <input
                            type='text'
                            name='descriptionLink'
                            placeholder='Whatsapp Link'
                            value={newProjectDetails.descriptionLink}
                            onChange={handleNewProjectInputChange}
                        />
                        <input
                            type='date'
                            name='startDate'
                            placeholder='Start Date'
                            value={newProjectDetails.startDate}
                            onChange={handleNewProjectInputChange}
                        />
                        <input
                            type='number'
                            name='duration'
                            placeholder='Duration'
                            value={newProjectDetails.duration}
                            onChange={handleNewProjectInputChange}
                        />
                        <select
                            name='clubName'
                            value={newProjectDetails.clubName}
                            onChange={handleNewProjectInputChange}
                        >
                            <option value='' disabled>Select Club</option>
                            {clubs.map((club, index) => (
                                <option key={index} value={club}>{club}</option>
                            ))}
                        </select>
                        <input
                            type='text'
                            name='projectPassword'
                            placeholder='Project Password'
                            value={newProjectDetails.projectPassword}
                            onChange={handleNewProjectInputChange}
                        />
                        <button onClick={handleNewProjectSubmit} className='modal-button'>Create Project</button>
                        <button onClick={() => setShowNewProjectModal(false)} className='modal-button'>Cancel</button>
                    </div>
                </div>
            )}

            {/* Edit Project Modal */}
            {showEditModal && (
                <div className='modal'>
                    <div className='modal-content'>
                        <h2>Edit Project</h2>
                        <input
                            type='text'
                            name='name'
                            placeholder='Project Name'
                            value={newProjectDetails.name}
                            onChange={handleNewProjectInputChange}
                        />
                        <input
                            type='text'
                            name='descriptionLink'
                            placeholder='Whatsapp Link'
                            value={newProjectDetails.descriptionLink}
                            onChange={handleNewProjectInputChange}
                        />
                        <input
                            type='date'
                            name='startDate'
                            placeholder='Start Date'
                            value={newProjectDetails.startDate}
                            onChange={handleNewProjectInputChange}
                        />
                        <input
                            type='number'
                            name='duration'
                            placeholder='duration'
                            value={newProjectDetails.duration}
                            onChange={handleNewProjectInputChange}
                        />
                        <select
                            name='clubName'
                            value={newProjectDetails.clubName}
                            onChange={handleNewProjectInputChange}
                        >
                            <option value='' disabled>Select Club</option>
                            {clubs.map((club, index) => (
                                <option key={index} value={club}>{club}</option>
                            ))}
                        </select>
                        <input
                            type='text'
                            name='projectPassword'
                            placeholder='Project Password'
                            value={newProjectDetails.projectPassword}
                            onChange={handleNewProjectInputChange}
                        />
                        <button onClick={handleEditProjectSubmit} className='modal-button'>Save Changes</button>
                        <button onClick={handleDeleteProject} className='modal-button delete'>Delete Project</button>
                        <button onClick={() => setShowEditModal(false)} className='modal-button'>Cancel</button>
                    </div>
                    
                </div>
            )}


            <NavBars />
        </div>
    );
};

export default Projects;